(function () {


    /**
     * @description
     * 
     * password is defined as app.data.custom.password change this to match your data.
     * 
     * @config 
         AUTHENTICATION: {
            type: "LocalAuthenticationStrategy",
            properties: {
                userRoles: ['jedi'], // sets a user role when logged in, this should match the user roles defined on the scene (umbraco?)
            }
        }
     */
    
        class LocalAuthenticationStrategy {
            constructor (config) {
                this.config = config;
                this.storageId = "auth";
                app.logging.log("LocalAuthenticationStrategy","LocalAuthenticationStrategy", this.storageId)
                app.radio.$on('app-before-start', () => this.decorateSceneAuth())
            }
    
            decorateSceneAuth () {
                app.data.scenes.forEach((scene, index) => {
                    if(index > 0) {
                        scene.authorization = {
                            inherit: false, 
                            roles: config.AUTHENTICATION.properties.userRoles
                        }
                    }
                })
            }
    
            login ({username, password}) {
    
                // options 
                if(password === app.data.custom.password) {
                    app.localStore.set(this.storageId, { username: 'john doe', roles: this.config.userRoles})
                    return Promise.resolve();
                }
                
                return Promise.reject();
            }
    
            logout () {
                // delete local storage entry
                app.localStore.remove(this.storageId);
                return Promise.resolve();
            }
           async isAuthenticated () {
                if(!app.localStore.has(this.storageId)) return Promise.reject();
                const stored = app.localStore.get(this.storageId)
                return Promise.resolve()
            }
            user () {
                return app.localStore.get(this.storageId);
            }
        }
    
        AuthenticationProvider.add("LocalAuthenticationStrategy", (config) => {
            app.logging.log("LocalAuthenticationStrategy", "creating new LocalAuthenticationStrategy")
            return new LocalAuthenticationStrategy(config);
        })
    }())